<script setup>
defineProps({
  windList: { type: Array, default: () => [] },
  latlon: { type: String, default: '' },
  pointName: { type: String, default: '' },
  sliderValue: { type: Number, default: 0 }
})
const isShowTable = defineModel('isShowTable', { type: Boolean })
const tableHead = ['時間', '風速\nm/s', '風向']
</script>

<template>
  <div
    class="slider__inner"
    :style="{ '--time-list-length': windList.length }"
  >
    <button
      class="toggle"
      @click="isShowTable = !isShowTable"
    />
    <div class="slider__inner-content">
      <div class="slider__inner-text">
        <p>
          {{ pointName || '--' }}
        </p>
        <p>
          {{ latlon || '--' }}
        </p>
      </div>
      <div
        v-if="windList.length"
        class="slider__inner-block"
      >
        <div class="slider__inner-table">
          <div class="slider__inner-table-column head">
            <div
              v-for="(text, i) in tableHead"
              :key="`head_${i}`"
              class="slider__inner-table-item"
            >
              <p>{{ text }}</p>
            </div>
          </div>
          <div class="slider__inner-table-body">
            <div
              v-for="(item, i) in windList"
              :key="`body_${i}`"
              class="slider__inner-table-column"
              :data-selected="i === sliderValue"
            >
              <div class="slider__inner-table-item">
                <p
                  v-if="item.date"
                  class="date"
                >
                  {{ item.date }}
                </p>
                <p>{{ item.time }}</p>
              </div>
              <div class="slider__inner-table-item">
                <p>{{ item.spd }}</p>
              </div>
              <div
                class="slider__inner-table-item"
                :data-dir="item.dir"
              >
                <svg
                  v-if="Number(item.spd) !== 0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                >
                  <path
                    d="M7 15.374L13.5 0.516607L7.1084 3.57715L7 3.62891L6.8916 3.57715L0.499023 0.516602L7 15.374Z"
                    stroke="black"
                    stroke-width="1"
                    :fill="item.color"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.slider {
  &__inner {
    position: relative;
    background-color: #eef1f8;
    .toggle {
      position: absolute;
      width: 21px;
      height: 21px;
      z-index: 2;
      top: 12px;
      right: 5px;
      background-color: #fff;
      border-radius: 50%;
      box-shadow: 0 2px 2px #00000026;
      cursor: pointer;
    }
    .toggle::before,
    .toggle::after {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 12px;
      height: 2px;
      border-radius: 100vmax;
      background-color: #3569C0;
      content: '';
    }
    .toggle::before {
      transform: translate(-50%, -50%);
    }
    .toggle::after {
      transform: translate(-50%, -50%) rotate(0deg);
      transition: transform .2s ease-in-out;
    }
    &:has(.slider__inner-table) {
      padding: 5px 10px;
    }
    &-content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
    }
    &-delete {
      position: absolute;
      right: 9px;
      top: -19px;
      z-index: 4;
      display: flex;
      transform: rotate(90deg);
      padding: 5px 3px 5px 4px;
      justify-content: center;
      align-items: center;
      gap: 2px;
      border-radius: 56px 0 0 56px;
      background: #EEF1F8;
      cursor: pointer;
      img {
        width: 12px;
        height: 12px;
      }
    }
    &-text {
      display: flex;
      flex-direction: column;
      p {
        height: 18px;
        color: #303030;
        text-align: center;
        font-size: 12px;
        line-height: 1.3em;
        &:first-child {
          height: 16px;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
    &-block {
      position: relative;
      &::before {
        position: absolute;
        width: 12px;
        height: calc(100% - 9px);
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        top: 0;
        right: 0;
        background: linear-gradient(270deg, rgb(0 0 0 / .17) 2.9%, rgb(0 0 0 / 0) 100%);
        z-index: 2;
        content: '';
      }
    }
    &-table {
      display: flex;
      width: 100%;
      overflow-x: scroll;
      padding-bottom: 3px;
      border-radius: 4px;
      &::-webkit-scrollbar {
        width : 6px;
        height: 6px;
      }
      &::-webkit-scrollbar-track {
        border-radius: 100vmax;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 100vmax;
        background-color: #c0c0c0;
      }
      &-body {
        display: flex;
        flex: 1;
      }
      &-column {
        position: relative;
        display: flex;
        flex-direction: column;
        &.head {
          position: sticky;
          left: 0;
          z-index: 5;
          &::before {
            position: absolute;
            width: 4px;
            height: 100%;
            top: 0;
            left: 100%;
            background: linear-gradient(90deg, rgb(0 0 0 / .17) 2.9%, rgb(0 0 0 / 0) 100%);
            content: '';
          }
          p {
            font-size: 13px;
            font-weight: 300;
            line-height: 14px;
            white-space: pre-wrap;
          }
        }
        &:last-child {
          .slider__inner-table-item {
            border-right: none;
          }
        }
        &:has(.date) {
          .slider__inner-table-item {
            border-left: solid 1px #c0c0c0;
          }
        }
        &[data-selected="true"] {
          &::after {
            position: absolute;
            width: 41px;
            height: 100%;
            top: 0;
            left: -1px;
            border-radius: 4px;
            border: solid 2px #88ACE0;
            box-shadow: 0 1px 2px 1px rgb(136 172 224 / .4);
            z-index: 3;
            content: '';
          }
        }
      }
      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 40px;
        height: 35px;
        background-color: #fff;
        border-bottom: solid 1px #c0c0c0;
        border-right: solid 1px #c0c0c0;
        @for $i from 1 through 16 {
          &[data-dir="#{$i}"] {
            svg {
              transform-origin: center;
              transform: rotate(($i) * 22.5deg);
            }
          }
        }
        &:last-child {
          border-bottom: none;
        }
        &:is(.head *) {
          border-right: none;
        }
        p {
          color: #303030;
          text-align: center;
          font-size: 13px;
          font-weight: 600;
          line-height: 1.25em;
          &.date {
            font-size: 12px;
            font-weight: 300;
          }
        }
      }
    }
  }
}
@media (min-width: 830px) {
  .slider {
    &__inner {
      &-delete {
        top: -22px;
        img {
          width: 15px;
          height: 15px;
        }
      }
      &-table {
        &-item {
          height: 40px;
          p {
            font-size: 15px;
          }
        }
      }
    }
  }
}
</style>
